import { Diligence } from '@/plugins/api'
import { keyBy } from 'lodash'

export default {
  namespaced: true,
  state: {
    studentDiligences: [],
    diligences: {},
  },
  actions: {
    async getStudentDiligences({ commit }, params) {
      const response = await Diligence.getStudentDiligences(params)
      commit('setStudentDiligences', response)
    },
    getStudentDiligencesExcel(_, params) {
      return Diligence.fetch(params)
    },

    async fetchDiligences({ commit }, options) {
      commit('setDiligences', await Diligence.fetch(options))
    },
    async createDiligence({ commit }, data) {
      try {
        const d = await Diligence.create(data)
        commit('setDiligence', d)
        return d
      } catch (e) {
        console.error(e)
      }
    },
    async updateDiligence({ commit }, { id, ...diligence }) {
      const d = await Diligence.update(id, diligence)
      commit('updateDiligence', d)
      return d
    },
    async removeDiligence({ commit }, id) {
      await Diligence.remove(id)
    },
  },
  mutations: {
    setStudentDiligences(state, data) {
      state.studentDiligences = data
    },
    setDiligences(state, diligences) {
      state.diligences = diligences.reduce(
        (accumulator, currentValue) => ({
          ...accumulator,
          [currentValue.id]: currentValue,
        }),
        {}
      )
    },
    setDiligence(state, diligence) {
      state.diligences = {
        ...state.diligences,
        [diligence.id]: diligence,
      }
    },
    updateDiligence(state, diligence) {
      const diligences = Object.values(state.diligences).map((a) => {
        if (diligence.id === a.id) return diligence
        else return a
      })
      state.diligences = keyBy(diligences, 'id')
    },
  },
  getters: {
    diligences: (state) => {
      return Object.values(state.diligences)
    },
  },
}
